import { useEffect } from 'react';
import NProgress from 'nprogress';
import { Loader2 } from 'lucide-react';

interface SuspenseLoaderProps {
  position?: 'fixed' | 'absolute';
  overlay?: boolean;
}

function SuspenseLoader({ position = 'fixed', overlay = false }: SuspenseLoaderProps) {
  useEffect(() => {
    NProgress.configure({ showSpinner: false });
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <div
      className={`flex items-center justify-center z-[1300] left-0 top-0 w-full h-full ${position === 'fixed' ? 'fixed' : 'absolute'}`}
    >
      <Loader2 size={40} strokeWidth={1.8} className="animate-spin text-brand-500/70" />
    </div>
  );
}

export default SuspenseLoader;
